import { useEffect } from "react";
import confetti from "canvas-confetti";
import { Trophy, Zap } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const Celebration = ({ open, onClose, title, subtitle, xp, children }) => {
  useEffect(() => {
    if (!open) return;
    const colors = ["#22a06b", "#f97316", "#3b82f6", "#facc15"];
    confetti({ particleCount: 120, spread: 80, origin: { y: 0.6 }, colors });
    const t = setTimeout(() => confetti({ particleCount: 80, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors }), 300);
    return () => clearTimeout(t);
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="celebration-modal" className="sm:max-w-md text-center rounded-3xl">
        <div className="mx-auto h-20 w-20 rounded-full bg-[hsl(var(--secondary-light))] grid place-items-center animate-pop">
          <Trophy size={38} className="text-[hsl(var(--secondary))]" />
        </div>
        <DialogTitle className="font-display text-2xl font-extrabold text-slate-900 text-center">{title}</DialogTitle>
        <DialogDescription className="text-slate-600 text-center">{subtitle}</DialogDescription>
        {xp > 0 && (
          <div data-testid="celebration-xp" className="mx-auto flex items-center gap-1.5 px-4 py-2 rounded-full bg-amber-50 text-amber-700 font-bold">
            <Zap size={18} className="fill-amber-400 text-amber-500" /> +{xp} XP
          </div>
        )}
        <div className="flex flex-col gap-2 mt-2">{children}</div>
      </DialogContent>
    </Dialog>
  );
};
